import {
  STORE_Addons,
  STORE_CSID,
  STORE_CSP,
  STORE_Cart,
  STORE_CartCheckoutData,
  STORE_CustomerDefaultAddress,
  STORE_CustomerName,
  STORE_DeliveryZoneID,
  STORE_DineType,
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_MTYPE,
  STORE_MobileAppCategory,
  STORE_NIC,
  STORE_PROMOTIONS,
  STORE_PhoneNo,
  STORE_SHEDULEDateNTime,
  STORE_SelectedMerchant,
  STORE_SelectedMerchantProduct,
  STORE_ZoneDescription,
  STORE_ZoneId,
  STORE_dtoCustomerAddressList,
  STORE_dtoMobileSettings,
  TEMP_STORE_CSID,
  TEMP_STORE_CustomerName,
  TEMP_STORE_OTP,
  TEMP_STORE_PhoneNo,
} from "../../../../database/store-names";
import {
  PT_COMPLETEORDERS,
  PT_PRIVACYPOLICY,
  PT_ADDRESSLIST,
  PT_PROFILE,
  PT_SIGNIN,
} from "../../../../routes/stack/paths/pt-profile";
import { CSP, ENCRYPT_STORAGE, currentver } from "../../../../config/config";
import { Get_CustomerDefaultAddress } from "../../../../database/get-stored-data";
import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { api_InactiveIOSUser } from "../../../../connection/api/api-profile";
import { SET_STORE_PAGE_URL } from "../../../../database/store-data";
import { dto_Customer } from "../../../../classes/dto-customer";
import { PT_HOME } from "../../../../routes/stack/paths/pt-home";
import ALert from "../../../../components/Alert";
import React from "react";
import "../../../../styles/css/pg-profile-menulist.css";

export default class MenuList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { DefaultAddress: "" };
  }

  async componentDidMount() {
    this.setState({
      DefaultAddress: await Get_CustomerDefaultAddress(),
    });
  }

  render() {
    let CSID = this.props.CSID;
    return (
      <div className="fadeInUp animated">
        {CSID === 0 ? (
          // && (CSP === "DT" || CSP === "MK")
          <li
            id="pg-profile-menu-line"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
            }}
            onClick={() => {
              this.props.navigate(PT_SIGNIN);
            }}
          >
            <i
              className="bi bi-person-plus"
              aria-hidden="true"
              id="pg-profile-menu-line-icon"
            />
            {/* Create Account */}
            Access Your Account
          </li>
        ) : null}

        {CSID !== 0 ? (
          <li
            id="pg-profile-menu-line"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              position: "relative",
            }}
            onClick={() => {
              this.props.navigate(
                PT_ADDRESSLIST.replace(":frompage", "profile"),
              );
              SET_STORE_PAGE_URL(PT_PROFILE);
            }}
          >
            <i
              className="bi bi-geo-alt"
              aria-hidden="true"
              id="pg-profile-menu-line-icon"
            />

            {/* {CSP !== "DT" && CSP !== "MK" ? (
              <div>Change Address</div>
            ) : ( */}
            <>
              <div style={{ flex: 1 }}>{this.state.DefaultAddress}</div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i
                  className="bi bi-caret-right-fill"
                  aria-hidden="true"
                  style={{
                    fontSize: "15px",
                    position: "absolute",
                    right: 10,
                  }}
                />
              </div>
            </>
            {/* )} */}
          </li>
        ) : null}

        {/* {CSID !== 0 && CSP !== "DT" && CSP !== "MK" ? ( */}
        <li
          id="pg-profile-menu-line"
          style={{
            fontSize: "15px",
            fontWeight: "bold",
          }}
          onClick={() => {
            this.props.navigate(
              PT_COMPLETEORDERS.replace(":frompage", "profile"),
            );
            SET_STORE_PAGE_URL(PT_PROFILE);
          }}
        >
          <i
            className="bi bi-view-list"
            aria-hidden="true"
            id="pg-profile-menu-line-icon"
          />
          Completed Orders
        </li>
        {/* // ) : null} */}

        <li
          id="pg-profile-menu-line"
          style={{
            fontSize: "15px",
            fontWeight: "bold",
          }}
          onClick={() => {
            window.location.href = "tel:" + dto_StartupPageLoadInfo.ContactUs;
          }}
        >
          <i
            className="bi bi-telephone-outbound"
            aria-hidden="true"
            id="pg-profile-menu-line-icon"
          />
          {"Contact Us"}
        </li>

        <li
          id="pg-profile-menu-line"
          style={{
            fontSize: "15px",
            fontWeight: "bold",
          }}
          onClick={() => {
            this.props.navigate(PT_PRIVACYPOLICY);
          }}
        >
          <i
            className="bi bi-arrow-repeat"
            aria-hidden="true"
            id="pg-profile-menu-line-icon"
          />
          Privacy Policy
        </li>

        {/* dto_Customer.PhoneNo === 9607540803 && */}
        {/* {CSID !== 0 &&  CSP !== "DT" && CSP !== "MK" ? (
          <li
            id="pg-profile-menu-line"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
            }}
            onClick={() => {
              this.DelectAccount();
            }}
          >
            <i
              className="bi bi-person-x"
              aria-hidden="true"
              id="pg-profile-menu-line-icon"
            />
            Delete Account
          </li>
        ) : null} */}

        {/* dto_Customer.PhoneNo === 94768030407 &&  */}
        {CSID !== 0 ? (
          <li
            id="pg-profile-menu-line"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
            }}
            onClick={() => {
              this.DelectAccount();
            }}
          >
            <i
              className="bi bi-person-x"
              aria-hidden="true"
              id="pg-profile-menu-line-icon"
            />
            Delete Account
          </li>
        ) : null}

        {CSP === "AV" ? (
          <li
            id="pg-profile-menu-line"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
            }}
          >
            <i
              className="bi bi-file-earmark-check"
              aria-hidden="true"
              id="pg-profile-menu-line-icon"
            />
            GST Registered 1107337GST501
          </li>
        ) : null}

        {CSID !== 0 ? (
          <li
            id="pg-profile-menu-line"
            style={{
              fontSize: "15px",
              fontWeight: "bold",
            }}
            onClick={() => this.handleSingout()}
          >
            <i
              className="bi bi-box-arrow-left"
              aria-hidden="true"
              id="pg-profile-menu-line-icon"
            />
            Sign Out
          </li>
        ) : null}

        {/* <p
          style={{
            display: CSP === "AV" ? "block" : "none",
            margin: 0,
            textAlign: "center",
            fontSize: 12,
            color: "#969696",
            fontWeight: "bold",
            paddingTop: "20px",
          }}
        >
          AVAS <br />
          GST Registered 1107337GST501
        </p> */}
      </div>
    );
  }

  async DelectAccount() {
    ALert.ConfirmationMessageBox({
      CancelButtonMessage: "No",
      ConfirmButtonText: "Yes",
      DismissButtonFunction: () => {},
      ConfirmButtonFunction: async () => {
        await api_InactiveIOSUser();
        await this.ClearStorage();
      },
      Tittle: "Delete Account",
      Text: "Do you want delete account from this app?",
    });
  }

  async handleSingout() {
    let message = "Do you want sign out from this app?";
    ALert.ConfirmationMessageBox({
      CancelButtonMessage: "No",
      ConfirmButtonText: "Yes",
      DismissButtonFunction: () => {},
      ConfirmButtonFunction: async () => {
        await this.ClearStorage();
      },
      Tittle: "Sign Out",
      Text: message,
    });
  }

  async ClearStorage() {
    dto_Customer.CusName = "";
    let csp = ENCRYPT_STORAGE.getItem(STORE_CSP);
    localStorage.clear();
    sessionStorage.clear();
    ENCRYPT_STORAGE.removeMultipleItems([
      STORE_CSID,
      STORE_NIC,
      STORE_ZoneId,
      STORE_ZoneDescription,
      STORE_DeliveryZoneID,
      STORE_MTYPE,
      STORE_dtoMobileSettings,
      STORE_DineType,
      STORE_PhoneNo,
      STORE_SelectedMerchant,
      STORE_SelectedMerchantProduct,
      STORE_MobileAppCategory,
      STORE_CustomerName,
      STORE_dtoCustomerAddressList,
      STORE_CustomerDefaultAddress,
      TEMP_STORE_CSID,
      TEMP_STORE_PhoneNo,
      TEMP_STORE_CustomerName,
      TEMP_STORE_OTP,
      STORE_Cart,
      STORE_CartCheckoutData,
      STORE_Addons,
      STORE_FinaleSelelctCartMerchantNZone,
      STORE_PROMOTIONS,
      STORE_SHEDULEDateNTime,
      STORE_CustomerDefaultAddress,
    ]);
    if (csp !== undefined) {
      this.props.navigate("/" + csp + "?ver=" + currentver);
    } else {
      this.props.navigate(PT_HOME);
    }
  }
}
